export default function ({ route }) {
  if (route.name === "orders" && Object.keys(route.query).length === 0) {
    // if (!route.query.hasOwnProperty("revoked_at")) {
    route.query.revoked_at = "isEmpty()"
    // }
  }
}
